<div class="d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center">
    <div class="l2-title">
      {{ [companies.Sea].includes(company) ? 'Customer/Contact Information' : 'Customer Information' }}
    </div>
    <div (click)="customerSearch()"
         *ngIf="!isDetail && showCustomerSearch"
         class="d-flex btn btn-customer-search ms-2">
      <i class="fa-regular fa-circle-user"></i>
      <span class="ms-1">
        Search
      </span>
    </div>
  </div>
  <ng-container *ngIf="customer && [companies.Sea].includes(company)" class="item-row">
    <div class="d-flex align-items-center">
      <ng-container *ngIf="!isDetail && showCustomerSearch">
        <ng-select (change)="setTicketAddress($event)"
                   [(ngModel)]="selectedAddress"
                   [clearable]="false"
                   [items]="addressOptions"
                   bindLabel="fullAddress"
                   class="form-control address-button me-2 add-btn"
                   placeholder="Select Saved Address">
        </ng-select>

        <ng-container *ngIf="!addressExist; else notExist">
          <button (click)="addFavoriteAddress()" class="btn btn-dark" type="button">
            <font-awesome>Add To Favorites</font-awesome>
          </button>
        </ng-container>
        <ng-template #notExist>
          <button (click)="deleteFavoriteAddress()" class="btn btn-dark" type="button">
            <font-awesome>Remove from Favorites</font-awesome>
          </button>
        </ng-template>
      </ng-container>
    </div>
  </ng-container>
</div>

<div *ngIf="[companies.Seca].includes(company)" class="item-row mb-8px">
  <div class="item-label">BP#</div>
  <div class="item-value">{{ customer?.bpNo }}</div>
</div>
<div *ngIf="[companies.Sea].includes(company)" class="item-row mb-8px">
  <div class="item-label">Employee/Bp #</div>
  <div class="item-value">{{ customer?.employeeNo || customer?.bpNo }}</div>
</div>
<div class="item-row mb-8px">
  <div class="item-label">First Name</div>
  <div class="item-value">{{ customer?.firstName }}</div>
  <div class="item-label">Last Name</div>
  <div class="item-value">{{ customer?.lastName }}</div>
</div>
<div class="item-row mb-8px">
  <div class="item-label">Phone Number</div>
  <div class="item-value">{{ customer?.cellPhone || customer?.homePhone }}</div>
  <div class="item-label">Email</div>
  <div class="item-value">{{ customer?.email }}</div>
</div>
<div class="item-row">
  <div class="item-label">Address</div>
  <div *ngIf="customer?.address?.zipcode" class="item-address">
    {{ customer?.address?.address2 ? customer?.address?.address2.concat(', ') : '' }}{{ customer?.address?.address1 }}
    , {{ customer?.address?.city }}, {{ customer?.address?.state }}
    , {{ customer?.address?.zipcode }}
  </div>
</div>
<div class="ticket-horizontal-line"></div>
